import { HousekeepingResponseSchemaType } from "../../../services/housekeeping/response/IndexHousekeepingResponse";
import { GetAllRoomTypeResponse, Room, RoomType } from "../../../services/room-type/response/GetAllRoomTypeResponse";

const MapRoomCalendar = ({ roomTypes, isUnsigmentChecked, showBaseOnRoomType, housekeeping, showClosedRooms = false }: { roomTypes: GetAllRoomTypeResponse, isUnsigmentChecked: boolean, showBaseOnRoomType: String, housekeeping?: HousekeepingResponseSchemaType, showClosedRooms?: boolean }) => {
    const is_housekeeping_enabled = true; // Set to true if housekeeping is enabled
    return roomTypes.data.flatMap((roomtype: RoomType, index: number) => {
        const { rooms, name, ...rest } = roomtype;

        // Kamar berstatus 'closed' disembunyikan secara default (tidak bisa dijual).
        // `showClosedRooms` dipakai Kalender Reservasi supaya staff bisa mengecek
        // apakah masih ada booking tersangkut di kamar tutup dan memindahkannya.
        //
        // PENTING: util ini SHARED dengan modul room-maintenance — karena itu
        // param-nya opsional dan default `false`, supaya pemanggil lain tidak
        // berubah perilaku.
        const mapRoom = (room: Room) => ({
            ...room,
            id: room.id,
            title: room.room_number,
            housekeeping: housekeeping?.data.find((hk) => hk.room_id === room.id) || null,
            is_housekeeping_enabled: is_housekeeping_enabled,
        });

        // Tidak ada .sort() di sini secara sengaja -- urutan kamar sekarang 100%
        // ditentukan backend lewat `rooms.sort_order` (diatur lewat drag-and-drop
        // di dialog "Update Room Number"). `.filter()` mempertahankan urutan asli
        // array, jadi kalender ikut urutan API apa adanya. Kalau di-sort ulang di
        // sini, kalender berisiko menampilkan urutan berbeda dari dropdown
        // reservasi/housekeeping yang mempercayai urutan API mentah.
        const availableRooms = rooms
            .filter((room) => room.status !== 'closed')
            .map(mapRoom);

        const closedRooms = rooms
            .filter((room) => room.status === 'closed')
            .map(mapRoom);

        const roomChildren = [...availableRooms];

        // Kamar closed dikelompokkan di bawah 1 baris header "Closed Room" --
        // mengikuti pola persis baris "Unassigned" di bawah -- supaya tidak
        // nyempil di antara kamar available yang urutannya cuma ikut nomor kamar.
        // Header cuma muncul kalau room type ini memang punya kamar closed,
        // supaya tidak ada grup kosong.
        if (showClosedRooms && closedRooms.length > 0) {
            roomChildren.push({
                id: `closed-${roomtype.id}`,
                title: "Closed Room",
                status: "closed-group",
                property_id: '',
                created_at: new Date().toISOString(),
                updated_at: new Date().toISOString(),
                room_type_id: roomtype.id,
                room_number: '',
                sort_order: 0,
                condition: "clean",
                housekeeping: null,
                is_housekeeping_enabled: is_housekeeping_enabled,
            });
            roomChildren.push(...closedRooms);
        }

        // Tambahkan data unsigment jika isUnsigmentChecked true
        if (isUnsigmentChecked) {
            // Tambahkan 'Unassigned' jika isUnsigmentChecked true
            roomChildren.push({
                id: `unsigment-${roomtype.id}`,
                title: "Unassigned",
                status: "unsigment",
                property_id: '',
                created_at: new Date().toISOString(),
                updated_at: new Date().toISOString(),
                room_type_id: roomtype.id,
                room_number: '',
                sort_order: 0,
                condition: "clean",
                housekeeping: null, // Tambahkan null untuk housekeeping jika tidak ada
                is_housekeeping_enabled: is_housekeeping_enabled, // Tambahkan properti ini jika diperlukan
            });
        } else {
            // Hanya tambahkan 'Unassigned' jika showBaseOnRoomType sesuai dengan roomtype.id
            const showUnsigment = showBaseOnRoomType === roomtype.id;
            console.log(showBaseOnRoomType, roomtype.id, showUnsigment);

            if (showUnsigment) {
                roomChildren.push({
                    id: `unsigment-${roomtype.id}`,
                    title: "Unassigned",
                    status: "unsigment",
                    property_id: '',
                    created_at: new Date().toISOString(),
                    updated_at: new Date().toISOString(),
                    room_type_id: roomtype.id,
                    room_number: '',
                    sort_order: 0,
                    condition: "clean",
                    housekeeping: null, // Tambahkan null untuk housekeeping jika tidak ada
                    is_housekeeping_enabled: is_housekeeping_enabled, // Tambahkan properti ini jika diperlukan
                });
            }
        }

        return {
            ...rest,
            id: roomtype.id,
            title: name,
            order: index + 1,
            children: roomChildren,
            type: 'roomType',
            housekeeping: housekeeping?.data.find((hk) => hk.room_type_id === roomtype.id),
            is_housekeeping_enabled: is_housekeeping_enabled, // Tambahkan properti ini jika diperlukan
        };
    });
};

export default MapRoomCalendar;
